<template>
  <section class="my-5">
    <div class="container">
      <div class="card border-colorful px-5" v-if="messages.length > 0">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h4 class="mb-0">
            {{ campaign ? $t('campaign_summary') : $t('summary_active_campaigns2') }}
          </h4>
          <div class="d-flex flex-row align-items-center">
            <i class="fas fa-minus me-3 text-muted fa-xs minimize" @click="toggleMinimize"></i>
          </div>
        </div>
        <div class="card-body py-4" v-if="!isMinimized">
          <div v-for="(msg, index) in messages" :key="index">
            <!-- Mensagem do bot -->
            <div v-if="msg.from === 'bot'" class="d-flex flex-row justify-content-center">
              <div class="position-relative">
                <div
                  v-if="msg.loading"
                  class="w-100 p-10"
                >
                  <Loader
                    :size="'small'"
                    :align="'start'"
                  />
                </div>
                <div
                  v-if="msg.text"
                  class="small px-2 mb-0"
                  v-html="msg.text"
                >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer text-center py-2" v-if="!isMinimized">
          <small>{{ $t('review_AI_generated_content') }}</small>
        </div>
      </div>
      <div
        v-if="messages.length <= 0 && loader"
        class="bg-light ms-3 mb-3 rounded-3 w-100 p-10"
      >
        <Loader
          :size="'small'"
          :align="'start'"
        />
      </div>
    </div>
  </section>
</template>

<script>

import IaAgentService from '@/modules/integrations/services/ai-agent-service'
import { mapState } from 'vuex'
import { marked } from 'marked'

import Loader from '@/components/common/Loader/Loader'

export default {
  props: ['request', 'campaign'],
  name: 'AiAgentCard',
  components: {
    Loader
  },
  data () {
    return {
      isMinimized: false,
      newMessage: '',
      messages: [
      ],
      loader: false
    }
  },
  created () {
    this.sendMessage()
  },
  computed: {
    ...mapState('users', {
      user: state => state.user
    })
  },
  methods: {
    /**
     * send message
     */
    async sendMessage () {
      const content = `${this.request} 
        campaign_id: ${this.campaign ? this.campaign.id : ''}
        company_id: ${this.user.company.id}
        bearer_token: ${window.localStorage.getItem('access_token')}
        language: ${this.user.language}
        status: ACTIVE`

      if (!content) return

      this.messages.push({ from: 'user', text: content })
      this.newMessage = ''

      // Mensagem de carregamento
      const loadingIndex = this.messages.length
      this.messages.push({ from: 'bot', text: '', loading: true })

      this.loader = true
      try {
        const res = await IaAgentService.askQuestions({
          message: content
        })
        // console.log(res.response.content)
        // Substituir mensagem de loading
        this.$set(this.messages, loadingIndex, {
          from: 'bot',
          text: marked(res.response.content) || this.$t('try_again_later'),
          loading: false
        })
      } catch (err) {
        this.$set(this.messages, loadingIndex, {
          from: 'bot',
          text: this.$t('error_communicating_with_server'),
          loading: false
        })
      }
      this.loader = false
    },
    /**
     * toogle minimize
     */
    toggleMinimize () {
      this.isMinimized = !this.isMinimized
    }
  }
}
</script>

<style lang="scss" scoped>
.card-header {
  min-height: 40px;
}
</style>
